import React from 'react';
import styled from 'styled-components';

const HelpDialogTraning3 = (props) => {
    return(
        <React.Fragment>
            ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝<br />
            <b>☆トレーニングガイドは<a href="https://englishcompany-mobile.jp/guide/" target="_blank" rel="noopener noreferrer">こちら</a>☆</b>
            ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝<br />

            <h2>STEP1. 黙読</h2>

            日本語をOFFにして英語だけを表示させた状態で、声を出さずに英文を読みましょう。<br />

            <h3>ポイント</h3>
            <Texts><Text>✓ </Text>半分以上内容が理解できない場合は教材の難易度を下げる<Text></Text></Texts>
            <br />

            <h2>STEP2. チャンクごとに意味を確認</h2>

            英語も日本語も表示させた状態で「英語をまとめて再生する」をタップします。英文を見ながら音声を聞き、日本語の意味を確認しましょう。その後、全体を一度音読し、内容が理解できているか確認します。<br />

            <h3>ポイント</h3>
            <Texts><Text>✓ </Text><Text>すべてのチャンクの意味をしっかり確認する</Text></Texts>
            <Texts><Text>✓ </Text><Text>理解できないチャンクが半分以上ある場合は、教材の難易度を下げる</Text></Texts>
            <br />
            ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝<br />
            <div><b>チャンクリーディングの効果</b></div>
            英文は意味のかたまりごとに区切ることができ、これを「チャンク」と呼びます。チャンクリーディングとは、英文をこのチャンクごとに読むトレーニング。繰り返すと、英語の語順のまま英文を理解できるようになります。<br />
            ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝<br />
            <br />

            <h2>STEP3. サイトトランスレーション</h2>

            「サイトトランスレーション」をタップします。音声が再生されたら、日本語が表示される前に、瞬時に内容を思い浮かべましょう。<br />

            <h3>ポイント</h3>
            <Texts><Text>✓ </Text><Text>間に合わない場合は、もう一度チャンクごとの内容を思い浮かべながら音読し、再度挑戦</Text></Texts>
            <br />
            ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝<br />
            <div><b>サイトトランスレーションの効果</b></div>
            英文の意味のかたまりごとに瞬時に訳を言ったり内容をイメージしたりするトレーニング。英語の語順のまま英文を理解できるようになるため、リーディングスピードが向上し、ネイティブスピードのリスニングもできるようになっていきます。<br />
            ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝<br />
            <br />

            <h2>STEP4. 音読① リピート</h2>

            日本語をOFFにして英語だけを表示させた状態で「英語をまとめて再生する」をタップします。音声に続いて1チャンクずつリピートしましょう。<br />

            <h3>ポイント</h3>
            <Texts><Text>✓ </Text><Text>できるだけ発音をまねし、さらに内容をイメージしながらリピートする</Text></Texts>
            <Texts><Text>✓ </Text><Text>うまく言えないチャンクは個別再生して練習する</Text></Texts>
            <br />
            ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝<br />
            <div><b>音読の効果</b></div>
            英文を目で追いながら声に出して読むトレーニング。リーディングスピードの向上、語彙や文法などの知識の定着、スピーキングスキルの土台作りに役立ちます。<br />
            ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝<br />
            <br />

            <h2>STEP5. 音読② Read and look-up（リード アンド ルックアップ）</h2>

            日本語をOFFにして英語だけを表示させた状態で、チャンクごとに音声を個別再生します。英文を見ながら音声を聞いたのち、顔を上げて（あるいは目をつむって）リピートしましょう。その後、英語を見て正しく言えたかを確認します。<br />

            <h3>ポイント</h3>
            <Texts><Text>✓ </Text><Text>頭の中で瞬時に内容をイメージしながらリピートする</Text></Texts>
            <Texts><Text>✓ </Text><Text>うまく言えないチャンクは個別再生して練習する</Text></Texts>
            <br />

            <h2>STEP6. 音読③ 暗唱</h2>

            英語も日本語も表示させた状態で、英文を見て最初から最後まで2、3回音読します。流暢に音読できるようになったら英語をOFFにし、日本語だけを見て英語を暗唱していきましょう。すべてのチャンクをスムーズに暗唱できるようになるまで、最初から最後まで2、3回繰り返します。<br />

            <h3>ポイント</h3>
            <Texts><Text>✓ </Text><Text>内容をイメージしながら暗唱する</Text></Texts>
            <Texts><Text>✓ </Text><Text>英語がすぐに出てこない、正確に言えない、自信がないときは、すぐに英語を表示させて確認する</Text></Texts>
            <Texts><Text>✓ </Text><Text>余裕があれば、日本語もOFFにして完全暗唱にトライ！</Text></Texts>
        </React.Fragment>
    );
}

export { HelpDialogTraning3 };

const Texts = styled.span`
    display: flex;
`;

const Text = styled.span`
    margin: 0;
`;